var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0C1.0768 0 0 1.076 0 2.4C0 3.724 1.0768 4.8 2.4 4.8C3.7232 4.8 4.8 3.7232 4.8 2.4C4.8 1.0768 3.7232 0 2.4 0ZM2.4 3.2C1.9592 3.2 1.6 2.8408 1.6 2.4C1.6 1.9592 1.9592 1.6 2.4 1.6C2.8416 1.6 3.2 1.9592 3.2 2.4C3.2 2.8408 2.8416 3.2 2.4 3.2Z",
    fill: "#0077B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 5.59998C1.0768 5.59998 0 6.67678 0 7.99998C0 9.32318 1.0768 10.4 2.4 10.4C3.7232 10.4 4.8 9.32318 4.8 7.99998C4.8 6.67678 3.7232 5.59998 2.4 5.59998ZM2.4 8.79998C1.9592 8.79998 1.6 8.44078 1.6 7.99998C1.6 7.55918 1.9592 7.19998 2.4 7.19998C2.8416 7.19998 3.2 7.55918 3.2 7.99998C3.2 8.44078 2.8416 8.79998 2.4 8.79998Z",
    fill: "#0077B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 11.2C1.0768 11.2 0 12.2768 0 13.6C0 14.9232 1.0768 16 2.4 16C3.7232 16 4.8 14.9232 4.8 13.6C4.8 12.2768 3.7232 11.2 2.4 11.2ZM2.4 14.4C1.9592 14.4 1.6 14.0408 1.6 13.6C1.6 13.1592 1.9592 12.8 2.4 12.8C2.8416 12.8 3.2 13.1592 3.2 13.6C3.2 14.0408 2.8416 14.4 2.4 14.4Z",
    fill: "#0077B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 1.59998H6.3999V3.19998H15.9999V1.59998Z",
    fill: "#0077B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 7.20001H6.3999V8.80001H15.9999V7.20001Z",
    fill: "#0077B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 12.8H6.3999V14.4H15.9999V12.8Z",
    fill: "#0077B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.019131652f6e1267571a08394a70b92e.svg";
export { ForwardRef as ReactComponent };